const DOCUMENT_TYPES = {
  pdf: { label: 'PDF', icon: 'mdi-file-pdf-box', color: '#E53935' },
  doc: { label: 'Word', icon: 'mdi-file-word-box', color: '#1565C0' },
  docx: { label: 'Word', icon: 'mdi-file-word-box', color: '#1565C0' },
  xls: { label: 'Excel', icon: 'mdi-file-excel-box', color: '#2E7D32' },
  xlsx: { label: 'Excel', icon: 'mdi-file-excel-box', color: '#2E7D32' },
  csv: { label: 'CSV', icon: 'mdi-file-delimited', color: '#2E7D32' },
  ppt: { label: 'PowerPoint', icon: 'mdi-file-powerpoint-box', color: '#EF6C00' },
  pptx: { label: 'PowerPoint', icon: 'mdi-file-powerpoint-box', color: '#EF6C00' },
  txt: { label: 'Texto', icon: 'mdi-file-document-outline', color: '#546E7A' },
  zip: { label: 'ZIP', icon: 'mdi-folder-zip', color: '#6D4C41' },
  rar: { label: 'RAR', icon: 'mdi-folder-zip', color: '#6D4C41' },
};

const DEFAULT_DOCUMENT_TYPE = {
  label: 'Documento',
  icon: 'mdi-file-document-outline',
  color: '#546E7A',
};

export function extractFilenameFromUrl(url) {
  if (!url || typeof url !== 'string') {
    return '';
  }

  try {
    const pathname = new URL(url).pathname;
    const segment = pathname.split('/').filter(Boolean).pop() || '';
    return decodeURIComponent(segment);
  } catch {
    const withoutQuery = url.split('?')[0].split('#')[0];
    const segment = withoutQuery.split('/').filter(Boolean).pop() || '';
    return decodeURIComponent(segment);
  }
}

export function getFileExtension(url, filename) {
  const name = filename || extractFilenameFromUrl(url);
  const match = name.match(/\.([a-z0-9]+)$/i);
  return match ? match[1].toLowerCase() : '';
}

export function isPdfDocument(url, filename) {
  return getFileExtension(url, filename) === 'pdf';
}

export function getDocumentTypeInfo(extension) {
  if (!extension) {
    return DEFAULT_DOCUMENT_TYPE;
  }
  return DOCUMENT_TYPES[extension] || {
    ...DEFAULT_DOCUMENT_TYPE,
    label: extension.toUpperCase(),
  };
}

export function formatFileSize(bytes) {
  if (bytes == null || bytes === '' || Number.isNaN(Number(bytes))) {
    return null;
  }

  const value = Number(bytes);
  if (value === 0) {
    return '0 Bytes';
  }

  const k = 1024;
  const sizes = ['Bytes', 'KB', 'MB', 'GB'];
  const i = Math.floor(Math.log(value) / Math.log(k));
  return `${parseFloat((value / Math.pow(k, i)).toFixed(2))} ${sizes[i]}`;
}

export function getGoogleGviewUrl(fileUrl) {
  return `https://docs.google.com/gview?url=${encodeURIComponent(fileUrl)}&embedded=true`;
}

export async function fetchRemoteFileSize(url) {
  if (!url) {
    return null;
  }

  try {
    const response = await fetch(url, { method: 'HEAD' });
    const contentLength = response.headers.get('content-length');
    return contentLength ? parseInt(contentLength, 10) : null;
  } catch {
    return null;
  }
}

export function resolveDocumentFilename(data) {
  if (!data) {
    return 'documento';
  }

  return (
    data.file_upload_filename ||
    extractFilenameFromUrl(data.file_upload) ||
    data.pill_name ||
    'documento'
  );
}
